export const choices = {
    multiple_choice: "Multiple Choice",
    single_choice: "Single Choice"

}

export const Role = {
organization: "organization",
    user: "user",
    admin: "admin",

}

export const Section = {
    Theory: 'Theory',
    Analytical: 'Analytical',
    Coding: 'Coding'
}

export const site_key="6LcUyforAAAAAF7teHxGdbWqyj2sKXK-yj0L8Oe1"
export const secret_key="6LcUyforAAAAAGXOTMaMtztqlJF7-RddHvvCAgRB"